import Image from "next/image";
import React from "react";
import type { StaticPageQuery } from "components/StaticPageTemplate";
import Container from "components/common/Container";
import HtmlContent from "components/common/HtmlContent";
import SectionHeader from "components/common/SectionHeader";
import { usePageMeta } from "hooks/usePageMeta";
import styles from "./StaticPageTemplate.module.css";

interface StaticPageContentProps {
  page: NonNullable<StaticPageQuery["page"]>;
}

// Shared rendering logic for static pages
export const StaticPageRenderer = ({ page }: StaticPageContentProps) => {
  return (
    <>
      {page.heroSection?.title && page.heroSection.summary && (
        <SectionHeader title={page.heroSection.title} summary={page.heroSection.summary} />
      )}
      {page.featuredImage?.node?.mediaItemUrl && (
        <div className="relative h-60">
          <Image
            src={page.featuredImage.node.mediaItemUrl}
            layout="fill"
            objectFit="cover"
            alt={page.title || "Featured image"}
          />
        </div>
      )}
      <Container>
        {page.title && <h1 className={styles.pageTitle}>{page.title}</h1>}
        {page.content && <HtmlContent>{page.content}</HtmlContent>}
      </Container>
    </>
  );
};

const StaticPageContent = ({ page }: StaticPageContentProps) => {
  usePageMeta(page?.title, page?.seo);

  return <StaticPageRenderer page={page} />;
};

export default StaticPageContent;
